import { Component, Inject, Input, OnDestroy } from "@angular/core";

import { OnInit } from "@angular/core";

import { FieldGeneratorService } from "../../services/field-generator.service";
import { MatDialog, fadeInItems } from "@angular/material";

import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MessageService } from '../../services/message.service';
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { UserService } from 'src/services/user.service';
import { UserComponent } from './user/user.component';
import { UserfcmkeyComponent } from "./userfcmkey/userfcmkey.component";

@Component({
  selector: "rm-manage-user",
  templateUrl: "./manage-user.component.html",
  styleUrls: ["./manage-user.component.css"]
})
export class ManageUserComponent implements OnInit, OnDestroy {
  hideToolbar: boolean = false;

  columns: any[] = [
    { name: 'photoUrl', displayName: "", type: 'image', style: "width: 78px; border-radius:39px;", editable: false },
    { name: "firstName", displayName: "First Name" },
    { name: "lastName", displayName: "Last Name" },
    { name: "dappUserId", displayName: "User Id" },
    { name: "email", displayName: "Email" },
    { name: "role", displayName: "Role" },
    { name: "createdon", displayName: "Created On", type: 'date', format: "DD/MM/YYYY", editable: false },
    { name: "actions", type: "actions", displayName: "" }
  ];
  subscriptions: any[] = [];
  users: any[] = [];
  role: any;

  totalCount: number = 0;
  gcp: string;
  pageSize: any = 5;

  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private userService: UserService,
    private ebService: EventBusService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.loadUsers(this.gcp);
      }
    ));
    // this.ebService.hideGcpChangeSource.next();

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
    });
    this.loadUsers(this.gcp);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadUsers(gcp, page?) {
    this.userService.getUsers(gcp, page).subscribe(
      (result: any) => {
        this.users = result['data'];
        this.totalCount = result.count;

        //add actions
        this.users.forEach(r => {
          if (r.gcp) {
            r['actions'] = [
              { name: 'edit', tip: 'Edit' }
            ];
          } else {
            r['actions'] = [];
          }

          if (r.isActive) {
            r['actions'].push({ name: 'not_interested', tip: 'De-activate user' });
          } else {
            r['actions'].push({ name: 'check_circle', tip: 'Activate user' });
          }
          r['actions'].push({
						name: 'vpn_key',
						tip: 'User Fcmkey'
					});

        });
        
      }
    );
  }

  add() {
    const dialogRef = this.dialog.open(UserComponent, {
      width: "640px",
      data: {
        title: "Add User"
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log("The dialog was closed", result);
      if (!result) {
        return;
      } else {
        var rec = result
        if (this.gcp) {
          rec["gcp"] = this.gcp;
        }
        this.userService
          .addUser(result)
          .subscribe(
            (response: any[]) => {
              console.log("User added");
              this.msgService.showSuccess(this.msgService.userCreate);
              this.loadUsers(this.gcp);
            },
            error => {
              console.log("Service error:");
            }
          );
      }
    });
  }

  onActionableClicked(e) {
    console.log("onActionableClicked:", e);
    // var rec = e.record;
    // switch (e.actionName) {
    //   case "name":
    //     this.dialog.open(MedicineDetailComponent, {
    //       width: "2400px",
    //       data: { medicineId: rec.gtin }
    //     });
    //     break;
    //   default:
    //     console.log("Unhandled actionable: ", e.actionName);
    // }
  }

  onActionClicked(e) {
    console.log("onActionClicked: ", e);
    var rec = e.record;
    console.log('rec',rec);
    switch (e.actionName.name) {
      case "edit":
        const dialogRef = this.dialog.open(UserComponent, {
          width: "640px",
          data: {
            title: "Edit User",
            user: rec
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log("The dialog was closed", result);
          if (!result) {
            return;
          }

          this.userService
            .updateUser(rec.id, result)
            .subscribe(
              (response: any[]) => {
                console.log("User edited");
                this.msgService.showSuccess(this.msgService.userUpdate);
                this.loadUsers(this.gcp);
              },
              error => {
                console.log("Service error:");
              }
            );
        });
        break;
      case "not_interested":
        const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            message: 'Are you sure you want to de-activate the user?'
          }
        });

        dialogRef1.afterClosed().subscribe(
          (result) => {
            if (result == 'yes') {
              this.userService.updateUser(rec.id, { isActive: false }).subscribe(
                () => {
                  this.msgService.showSuccess(this.msgService.userDeactivate);
                  this.loadUsers(this.gcp);
                }
              );
            }
          });
        break;
      case "check_circle":
        const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            message: 'Are you sure you want to activate the user?'
          }
        });

        dialogRef2.afterClosed().subscribe(
          (result) => {
            if (result == 'yes') {
              this.userService.updateUser(rec.id, { isActive: true }).subscribe(
                () => {
                  this.msgService.showSuccess(this.msgService.userActivate);
                  this.loadUsers(this.gcp);
                }
              );
            }
          });
        break;
        case "vpn_key":
				this.showUserFcmkeyListDialog(rec);
			break;
      default:
        console.log("Unhandled action: ", e.actionName);
    }
  }

  styleRow(rec) {
    if (!rec.isActive) {
      return "recalled-row";
    }
  }

  showInActiveUserTip(rec) {
    if (!rec.isActive) {
      return 'User has been de-activated.';
    }
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.loadUsers(this.gcp, page);
  }

  showUserFcmkeyListDialog(rec) {
		const dialogRef = this.dialog.open(UserfcmkeyComponent, {
			width: "600px",
            data: rec
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == 'yes') {
				// this.getSegments();
			}
        });
    }
    
}